// Import micromodal
import MicroModal from 'micromodal'; // es6 module
import flatpickr from 'flatpickr';
import Swiper from 'swiper';

import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Tabs } from 'flowbite';
import 'photoswipe/style.css';

// Import micromodal

document.addEventListener('DOMContentLoaded', () => {

	// Initialize MicroModal
	// Currently, you can find a demo micromodal in the page-tempalate.php file
	MicroModal.init({
		openTrigger: 'data-custom-open',
		disableScroll: false,
		awaitCloseAnimation: true
	})

	let villaSearchArea = document.getElementById('listing-search-area');

	if(villaSearchArea){
		let searchButton = document.getElementById('search-area');

		searchButton.addEventListener( 'click', function (){
			let urlParams = new URLSearchParams(window.location.search);
			let areaValue = urlParams.get('_area');
			window.location.href = '/villas/?_area=' + areaValue;
		})
	}

	const currentURL = window.location.href; // Get the current URL

	document.querySelectorAll('.sub-menu .menu-item').forEach(item => {
		const link = item.querySelector('a');
		if (link && link.href === currentURL) {
			item.classList.add('sub-current-menu-item'); // Add class if it matches the current URL
		} else {
			item.classList.remove('sub-current-menu-item'); // Remove class otherwise
		}
	});

	// Add click event listener for updating the active state on click
	document.querySelectorAll('.sub-menu .menu-item').forEach(item => {
		item.addEventListener('click', function (event) {
			// Remove 'sub-current-menu-item' class from all submenu items
			document.querySelectorAll('.sub-menu .menu-item').forEach(i => {
				i.classList.remove('sub-current-menu-item');
			});
			// Add 'sub-current-menu-item' class to the clicked item
			this.classList.add('sub-current-menu-item');
		});
	});
})

document.addEventListener('facetwp-loaded', function() {
	const facetName = 'area'; // Replace with the actual facet name
	const selectElement = document.querySelector('.facetwp-facet-' + facetName + ' select');

	// Function to remove the default option
	function removeDefaultOption() {
		const defaultOption = selectElement.querySelector('option[value=""]');
		if (defaultOption) {
			defaultOption.remove();
		}
	}

	// Call the function to remove the default option
	removeDefaultOption();

	// Ensure the "ALL" option doesn't already exist to prevent duplicates
	if (!Array.from(selectElement.options).find(option => option.value === 'all_cape_town')) {
		const allOption = new Option('All of Cape Town', 'all_cape_town');
		selectElement.add(allOption, 0); // Add "ALL" option at the top
	}

	selectElement.addEventListener('change', () => {
		if (selectElement.value === 'all_cape_town') {
			// Programmatically select all options except the "ALL" option
			Array.from(selectElement.options).forEach(option => {
				if (option.value !== 'all_cape_town') {
					option.selected = true;
				}
			});

			// Trigger the FacetWP refresh to apply the filter
			FWP.refresh();
		}
	});

	// Remove the default option whenever FacetWP is refreshed
	document.addEventListener('facetwp-refresh', function() {
		removeDefaultOption();
	});

});
